import makeStyles from '@mui/styles/makeStyles';

const default_color_blue = "#308CDB";
const default_color_text = "#465869";
const default_color_gray = "#EDF5FB";
const default_background_chip = "#FAFDFF";

const styles = makeStyles((theme) => ({
  infoSection: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
  },
  infoLabel: {
    color: default_color_blue,
    font: "600 14px/24px Manrope",
    marginBottom: 4,
  },
  infoText: {
    color: default_color_text,
    font: "500 14px/24px Manrope",
  },
  chipWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 8,
  },
  chip: {
    backgroundColor: default_color_gray,
    padding: "4px 8px",
    height: 28,
    borderRadius: 4,
    color: default_color_blue,
    "& span": {
      padding: 0,
    },
  },
  section: {
    marginTop: 16,
  },
  accordion: {
    boxShadow: "none",
    backgroundColor: default_color_gray,
    borderRadius: "12px !important",
    font: "700 16px Manrope",
    textTransform: "capitalize",
  },
  addressSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    gap: 16,
  },
  infoTextAccordion: {
    width: "190px",
    color: default_color_text,
    font: "500 14px/24px Manrope",
  },
  badge: {
    backgroundColor: default_background_chip,
    width: 40,
    height: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  badgeWithoutBackground: {
    width: 40,
    height: 40,
  },
  accordionAddress: {
    marginBottom: 12,
    padding: "0px !important",
  },
  accordionLabel: {},
}));

export default styles;
